import resume from '../assets/pdf/resume.pdf'
import anand_img from "../assets/png/Anand.jpeg"

export const headerData = {
    name: 'Ananda Gouda',
    title: "Full stack Web Developer",
    desciption:"So many of our dreams at first seem impossible, then they seem improbable, and then, when we summon the will, they soon become inevitable.",
    image: anand_img,
    resumePdf: resume
}
